import axios from 'axios';
import {backendHost} from '../../config';

export const getGames = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/games/game`, {params});
};